import moment from 'moment';

import { HoursOfOperation, Time } from '../../entity/hours-of-operation';
import { AddressTransformer, StateTransformer } from '../transformers/address';
import { CoordinateTransformer } from '../transformers/coordinate';
import { } from "../transformers/corporate";

import { EVCStation, Distance, EVCStationCategory, EVCStationThirdPartyStatus, EVCStationThirdPartyList } from '../../entity/location/evcstation';
import { EVCStationStatus } from "../../entity/location/evcstation";
import { BranchTransformer } from "../transformers/corporate";
import { EVStationBranch, BranchStatus } from "../../entity/corporate/corporateDetails"

export class StationTransformer {
    transform(stationInfo: any): EVCStation {
        let hoursOfOperations: HoursOfOperation[] = []
        let weeks = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday", "holiday"]
        for (let index = 0; index < weeks.length; index++) {
            const week = weeks[index];
            let startTime = stationInfo[week + "StartTime"]
            let endTime = stationInfo[week + "EndTime"]
            if(startTime && endTime) {
                
                startTime = startTime.split(":")
                endTime = endTime.split(":")
                let st = new Time(parseInt(startTime[0]), parseInt(startTime[1]));
                let et =  new Time(parseInt(endTime[0]), parseInt(endTime[1]))
                hoursOfOperations.push(new HoursOfOperation(
                    index, st, et
                    // new Time(parseInt(startTime[0]), parseInt(startTime[1])),
                    // new Time(parseInt(endTime[0]), parseInt(endTime[1]))
                ))
            }
        }
        let contactInfo = stationInfo.contactDetail
        let station = new EVCStation(
            stationInfo.stationId,
            stationInfo.stationName,            
            moment(stationInfo.effectiveFrom, moment.ISO_8601).toDate(),
            moment(stationInfo.effectiveTo, moment.ISO_8601).toDate(),
            new EVCStationStatus(stationInfo.status.code, stationInfo.status.description),
            new EVCStationCategory(stationInfo.stationCategory.code, stationInfo.stationCategory.description)
            // new EVCStationThirdPartyStatus(stationInfo.thirdPartyStatus.code, stationInfo.thirdPartyStatus.description)
        )
        if(contactInfo.city) {
            station.address = new AddressTransformer().transform(contactInfo)
        }   
        if(stationInfo.thirdPartyInfo != undefined) {
            station.thirdPartyInfo = new EVCStationThirdPartyList(stationInfo.thirdPartyInfo.thirdPartyId, stationInfo.thirdPartyInfo.thirdPartyName, stationInfo.thirdPartyInfo.descriptions, stationInfo.thirdPartyInfo.imgUrl)
        }
        station.landline = contactInfo.landline
        station.mobile = contactInfo.mobile
        station.email = contactInfo.email
        if(contactInfo.stationLocation) {
            station.coordinate = new CoordinateTransformer().transform(contactInfo.stationLocation)
        }
        station.hoursOfOperations = hoursOfOperations
        let distanceValue = stationInfo.distance
        let distanceDescription = stationInfo.distanceText
        station.distance = new Distance(distanceValue, "km", distanceDescription)
        station.distributionNode = stationInfo.distributionNodeDetails
        station.rating = stationInfo.stationRating
        let branchInfo = stationInfo.branchDetails;
        
        if(branchInfo) {
            station.branch = new EVStationBranch(
                branchInfo.corporateId,
                branchInfo.corporateName,
                branchInfo.branchId,
                branchInfo.branchName,
                new BranchStatus(branchInfo.status.code, branchInfo.status.description, branchInfo.status.additionalinfo, branchInfo.status.remarks)
            )
        }
        return station
    }

    deTransform(station: EVCStation): any {
        let stationInfo: any = {
            stationId: station.id,
            stationName: station.name,
            effectiveFrom: moment(station.effectiveOn).toISOString(),
            effectiveTo: moment(station.effectiveTill).toISOString(),
            distributionNodeDetails: station.distributionNode,
            status: {
                code: station.status.id
            },
            stationCategory: {
                code: station.stationCategory.id
            }
            
            // thirdPartyStatus: {
            //     code: station.thirdPartyStatus.id
            // }
        }
        let hoursOfOperationInfo: any = {}
        let weeks = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday", "holiday"]
        if(station.hoursOfOperations) {
            station.hoursOfOperations.forEach(hoursOfOperation => {
                let week = weeks[hoursOfOperation.weekDay]
                hoursOfOperationInfo[week + "StartTime"] = hoursOfOperation.opensAt.toString()
                hoursOfOperationInfo[week + "EndTime"] = hoursOfOperation.closesAt.toString()
            })
        }
        if(station.thirdPartyInfo) {
            stationInfo.thirdPartyInfo = station.thirdPartyInfo;
        }
        let contactDetail = {}
        if (station.address) {
            contactDetail = {     
                ...contactDetail,           
                ... new AddressTransformer().deTransform(station.address)
            }            
        }
        if (station.coordinate) {
            let coordinateInfo = new CoordinateTransformer().deTransform(station.coordinate)
            contactDetail = {
                ...contactDetail,
                stationLocation: coordinateInfo
            }
        }
        contactDetail = {
            ...contactDetail,
            mobile: station.mobile,
            landline: station.landline,
            email: station.email
        }
        if(station.id) {
            contactDetail = {
                ...contactDetail,
                stationDetailId: station.id,
                rowStatus: {
                    code: "A"
                }
            }            
        }
        if(station.branch) {
            stationInfo.branchInfo = station.branch
        }
        
        return {
            ...stationInfo,
            ...hoursOfOperationInfo,
            contactDetail : contactDetail
        }
    }
}